import { supabase } from './supabase';

export const API_URL = process.env.REACT_APP_API_URL || '';
export const isLocalAvailable = () => !!API_URL;

// Calls to the Express backend carry the Supabase session token as a Bearer
// header; the server verifies it and resolves the user.
export const apiFetch = async (path, options = {}) => {
  const { headers, ...rest } = options;
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  const merged = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(headers || {}),
  };
  if (rest.body && !('Content-Type' in merged) && !('content-type' in merged)) {
    merged['Content-Type'] = 'application/json';
  }
  return fetch(`${API_URL}${path}`, { ...rest, headers: merged });
};
